import {
  type GraphSidePanelContentId,
  type PathLookupType,
  pathLookupTypes,
} from '@ipfabric/utils';

export type IntentVerificationTabId =
  | 'defined-rules'
  | 'builtin-rules'
  | 'path-checks';
export type NetworkViewerTabId = 'dataInput' | 'visualizationSetup';
export type PathLookupTabId =
  | 'dataInput'
  | 'visualizationSetup'
  | 'resultDetails';
export type TopologyLayoutSettingsTabId = 'protocols' | 'devices';

const pathLookupDataInputTabIds = pathLookupTypes;
export type PathLookupDataInputTabId = PathLookupType;
export const isPathLookupDataInputTabId = (
  value?: string | null,
): value is PathLookupDataInputTabId =>
  pathLookupDataInputTabIds.includes(value as PathLookupDataInputTabId);

export type PathLookupVisualizationSetupTabId = 'edgeColors' | 'nodeColors';

export interface GraphSidePanelData {
  open: boolean;
  contentId: GraphSidePanelContentId;
  intentVerificationTabId: IntentVerificationTabId;
  networkViewerTabId: NetworkViewerTabId;
  pathLookupTabId: PathLookupTabId;
  pathLookupDataInputTabId: PathLookupDataInputTabId;
  pathLookupVisualizationSetupTabId: PathLookupVisualizationSetupTabId;
  topologyLayoutSettingsTabId: TopologyLayoutSettingsTabId;
}
